import { render, staticRenderFns } from "./recharge_record.vue?vue&type=template&id=80b0bffc&scoped=true"
import script from "./recharge_record.vue?vue&type=script&lang=ts"
export * from "./recharge_record.vue?vue&type=script&lang=ts"
import style0 from "./recharge_record.vue?vue&type=style&index=0&id=80b0bffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b0bffc",
  null
  
)

export default component.exports